module.exports = __webpack_public_path__ + "img/elementlengths_jaka.38079e9a.png";